import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bokunlokid',
  templateUrl: './bokunlokid.component.html',
  styleUrls: ['./bokunlokid.component.css']
})
export class BokunlokidComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
